
import { Component, OnInit, Input } from '@angular/core';
import { CriticaService } from 'src/app/service/critica/critica.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'app-cartorio-extrajudicial-critica',
  templateUrl: './cartorio-extrajudicial-critica.component.html',
  styleUrls: ['./cartorio-extrajudicial-critica.component.css']
})
export class CartorioExtrajudicialCriticaComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  municipio: any;
  cartorioComponente: any;
  localidade: any[];
  localidadeStr: String = '';
  listaMunicipio: any[];
  cartoriosFiltrados: any[];

  constructor(
    public service: CriticaService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {
    this.preencherListaClassificacao();
    this.preencherListaMunicipio();

    if(this.visualizacao || this.edicao) {

      this.cartoriosFiltrados = this.service.critica.value.listaCartorio
      .filter(cartorio => cartorio.id.municipio.nome === this.service.critica.controls.municipio.value);

    }

  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.critica.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.critica.value.assunto.id);
  }

  preencherListaMunicipio() {
    this.listaMunicipio = this.service.critica.value.listaCartorio.map(
      cartorio => cartorio.id.municipio.nome);
    return (this.listaMunicipio = [...new Set(this.listaMunicipio)].sort());
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.critica.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.critica.controls[str].touched &&
      this.service.critica.controls[str].errors != null;
  }

  filtrarCartorios() {

    this.cartoriosFiltrados = this.service.critica.value.listaCartorio
      .filter(cartorio => cartorio.id.municipio.nome === this.service.critica.controls.municipio.value);

    this.cartoriosFiltrados.sort((cartorio1, cartorio2) =>
      (cartorio1.nomeServico > cartorio2.nomeServico ? 1 : -1));

    if(!this.visualizacao && this.edicao) {

      this.service.critica.controls.localidade.setValue('');
      this.service.critica.controls.cartorio.setValue('');

    }
    this.service.critica.controls.cartorio.enable();

  }

  preencherLocalidade() {

    const localidade = this.service.critica.value.listaCartorio
      .find(cartorio => cartorio.nomeServico === this.service.critica.controls.cartorio.value && cartorio.id.municipio.nome === this.service.critica.controls.municipio.value);

    this.localidadeStr = localidade ?
      (localidade.tLogCodigo ? (localidade.tLogCodigo + '. ') : '') +
      (localidade.nomeLogradouro ? (localidade.nomeLogradouro + ', ') : '') +
      (localidade.numeroLogradouro ? (localidade.numeroLogradouro + ', ') : '') +
      (localidade.complementoLogradouro ? (localidade.complementoLogradouro + ', ') : '') +
      (localidade.bairro ? (localidade.bairro) : '') : null;

    return this.service.critica.controls.localidade.setValue(this.localidadeStr);

  }
}
